import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2eec086e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wp1200 p-0" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-column mt-3 px-3"
}
const _hoisted_3 = { class: "mb-0 font-bold" }
const _hoisted_4 = { class: "mt-0" }
const _hoisted_5 = { class: "mt-0" }
const _hoisted_6 = { class: "mt-0" }
const _hoisted_7 = {
  key: 1,
  class: "flex flex-column mt-3 px-3"
}
const _hoisted_8 = { class: "font-bold" }
const _hoisted_9 = { class: "mt-0" }
const _hoisted_10 = { class: "flex justify-content-between align-items-center p-3 pt-4 px-3" }
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"flex gap-3\" data-v-2eec086e><button class=\"iconButton cursor-auto\" data-v-2eec086e><svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-2eec086e><path d=\"M10 20C9.77221 19.9998 9.55382 19.8976 9.39285 19.7159L1.63735 10.949C0.58785 9.74226 0 8.11981 0 6.43C0 4.74019 0.58785 3.11773 1.63735 1.91097C2.70077 0.712526 4.14301 0.0392591 5.64684 0.0392591C7.15066 0.0392591 8.59291 0.712526 9.65633 1.91097L10 2.24667L10.3208 1.88514C10.8465 1.28605 11.4728 0.810847 12.1632 0.487213C12.8535 0.163579 13.594 -0.00201848 14.3417 6.37636e-05C15.0886 -0.00370766 15.8286 0.159858 16.5189 0.481255C17.2092 0.802652 17.8359 1.27547 18.3627 1.87223C19.4121 3.079 20 4.70145 20 6.39126C20 8.08108 19.4121 9.70353 18.3627 10.9103L10.6072 19.6772C10.5304 19.7742 10.437 19.8528 10.3327 19.9082C10.2284 19.9637 10.1152 19.9949 10 20ZM5.65829 1.92388C5.13801 1.91961 4.62213 2.03151 4.14041 2.25311C3.65869 2.47472 3.22068 2.80165 2.85165 3.21503C2.10803 4.05706 1.69056 5.19676 1.69056 6.38481C1.69056 7.57286 2.10803 8.71255 2.85165 9.55458L10 17.663L17.1369 9.58041C17.5065 9.16431 17.7997 8.67019 17.9997 8.1263C18.1998 7.5824 18.3027 6.9994 18.3027 6.41063C18.3027 5.82186 18.1998 5.23886 17.9997 4.69497C17.7997 4.15107 17.5065 3.65695 17.1369 3.24085C16.7707 2.82669 16.3349 2.49914 15.8549 2.27742C15.3749 2.0557 14.8604 1.94428 14.3417 1.9497C13.8214 1.94543 13.3055 2.05733 12.8238 2.27894C12.3421 2.50054 11.9041 2.82747 11.5351 3.24085L10.6072 4.28669C10.4433 4.46196 10.2259 4.55968 10 4.55968C9.77407 4.55968 9.55674 4.46196 9.39285 4.28669L8.46494 3.24085C8.09779 2.82281 7.66063 2.49112 7.17883 2.26504C6.69703 2.03896 6.18018 1.923 5.65829 1.92388Z\" data-v-2eec086e></path></svg></button><div class=\"flex flex-column gap-2\" data-v-2eec086e><span class=\"text-primary font-semibold\" data-v-2eec086e>Mestna knjižnica</span><span class=\"text-600\" data-v-2eec086e>3 km</span></div></div>", 1)
const _hoisted_12 = { class: "flex flex-column sm:flex-row align-items-end sm:align-items-center gap-2" }
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"flex gap-2\" data-v-2eec086e><div class=\"flex gap-1 align-items-center\" data-v-2eec086e><strong data-v-2eec086e>2</strong><i class=\"icon-warpit_icon_bike text-2xl text-600\" data-v-2eec086e></i></div><div class=\"flex gap-1 align-items-center\" data-v-2eec086e><strong data-v-2eec086e>10</strong><i class=\"icon-warpit_icon_lock text-xl text-600\" data-v-2eec086e></i></div></div>", 1)
const _hoisted_14 = { key: 2 }
const _hoisted_15 = ["onClick", "onKeyup"]
const _hoisted_16 = { class: "flex gap-3" }
const _hoisted_17 = { class: "flex flex-column gap-2" }
const _hoisted_18 = { class: "text-primary font-semibold" }
const _hoisted_19 = { class: "text-600" }
const _hoisted_20 = { class: "flex flex-column sm:flex-row align-items-end sm:align-items-center gap-2 flex-shrink-0" }
const _hoisted_21 = { class: "flex gap-2" }
const _hoisted_22 = {
  key: 0,
  class: "icon-warpit_icon_bike text-2xl text-600"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_FavouriteButton = _resolveComponent("FavouriteButton")!
  const _component_InfinityScroll = _resolveComponent("InfinityScroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isLoading && !_ctx.user)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("bikes.guest")), 1),
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("bikes.guest_description")), 1),
          _createElementVNode("p", _hoisted_5, [
            _createTextVNode(_toDisplayString(_ctx.$t("bikes.guest_instruction_1")) + " ", 1),
            _createVNode(_component_router_link, {
              to: { name: 'Login' },
              class: "font-bold"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("bikes.here")), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("p", _hoisted_6, [
            _createTextVNode(_toDisplayString(_ctx.$t("bikes.guest_instruction_2")) + " ", 1),
            _createVNode(_component_router_link, {
              to: { name: 'Register' },
              class: "font-bold"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("bikes.here")), 1)
              ]),
              _: 1
            })
          ])
        ]))
      : (!_ctx.isLoading && _ctx.stations.data.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("bikes.no_favourites")), 1),
            _createElementVNode("p", _hoisted_9, [
              _createTextVNode(_toDisplayString(_ctx.$t("bikes.no_favourites_instruction_1")) + " ", 1),
              _createElementVNode("strong", null, _toDisplayString(_ctx.$t("bikes.no_favourites_instruction_2")), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("bikes.no_favourites_instruction_3")), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.$t("bikes.card.available")) + ":", 1),
                _hoisted_13
              ])
            ]),
            _createVNode(_component_Divider, { class: "m-0" })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createVNode(_component_InfinityScroll, {
              onLoadNextPage: _ctx.loadStations,
              data: _ctx.stations,
              loading: _ctx.isLoading,
              "dont-use-mobile-handler": true,
              class: "list"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stations.data, (station) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: station.id
                  }, [
                    _createElementVNode("div", {
                      tabindex: "0",
                      class: "flex justify-content-between align-items-center gap-1 p-3 pt-4 px-3 cursor-pointer",
                      onClick: ($event: any) => (
              _ctx.$router.push({
                name: 'BikesById',
                params: { id: station.id },
              })
            ),
                      onKeyup: _withKeys(($event: any) => (
              _ctx.$router.push({
                name: 'BikesById',
                params: { id: station.id },
              })
            ), ["enter"])
                    }, [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_FavouriteButton, {
                          item: station,
                          onSetFavourite: ($event: any) => (_ctx.deleteFavouriteStation(station))
                        }, null, 8, ["item", "onSetFavourite"]),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("span", _hoisted_18, _toDisplayString(station.name), 1),
                          _createElementVNode("span", _hoisted_19, _toDisplayString((station.distance / 1000).toFixed(1)) + " km " + _toDisplayString(_ctx.$t("bikes.from_center")), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t("bikes.card.available")) + ": " + _toDisplayString(station.bikes_total_available), 1),
                        _createElementVNode("div", _hoisted_21, [
                          (station.bikes_regular_available !== null)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_22))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ], 40, _hoisted_15),
                    _createVNode(_component_Divider, { class: "m-0" })
                  ]))
                }), 128))
              ]),
              _: 1
            }, 8, ["onLoadNextPage", "data", "loading"])
          ]))
  ]))
}